<section class="jumbotron">
  <div class="container position-relative">
    <div class="jumbotron-content text-white text-center">
      <h1 class="font-weight-bolder text-title-header">{{'team.our_team' | translate}}</h1>
    </div>
  </div>
</section>
<section class="bg-green-qaira">
  <div class="container py-4 text-center text-white">
    <p class="p-subtitle">{{'team.description' | translate}}</p>
  </div>
</section>
<section class="img-section">
</section>
<!-- <section class="bg-white p-0">
  <div class="back-dron py-5 mb-2">
    <div class="py-5"></div>
  </div>
</section> -->
<!-- SECCION JUNTA DIRECTIVA -->
<section class="section-wave">
  <svg class="wave-top" viewBox="0 0 500 150" preserveAspectRatio="none">
    <path d="M-0.27,149.50 C115.97,-14.30 374.43,-3.45 500.27,150.48 L501.41,152.45 L-1.97,150.48 Z">
    </path>
  </svg>
  <div class="container py-2 text-center">
    <h1 class="font-weight-bolder">{{'team.board' | translate}}</h1>
    <div class="row">
      <div class="col-lg-3">
        <div class="item-person">
          <div class="item-person-img" style="background: url(../../../../assets/img/NOSOTROS/Team/foto\ monica.svg);">
          </div>
          <span class="text-blue-qaira"><b>Mónica Abarca</b></span> <br>
          <span class="text-sm">{{'team.monica_title' | translate}}</span>
          <p class="text-sm text-justify mt-3">{{'team.monica_description' | translate}}</p>
          <div class="item-person-media">
            <a href="https://www.linkedin.com/in/monicaabarca/" target="_blank">
              <img src="../../../../assets/img/NOSOTROS/Team/logo linkedin.svg" alt="">
            </a>
            <a href="#">
              <img src="../../../../assets/img/NOSOTROS/Team/logo twitter.svg" alt="">
            </a>
          </div>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="item-person">
          <div class="item-person-img" style="background: url(../../../../assets/img/NOSOTROS/Team/carlos.svg);">
          </div>
          <span class="text-blue-qaira"><b>Carlos Saito</b></span> <br>
          <span class="text-sm">{{'team.carlos_title' | translate}}</span>
          <p class="text-sm text-justify mt-3">{{'team.carlos_description' | translate}}</p>
          <div class="item-person-media">
            <a href="https://www.linkedin.com/in/carlos-saito-42b9497/" target="_blank">
              <img src="../../../../assets/img/NOSOTROS/Team/logo linkedin.svg" alt="">
            </a>
            <a href="#">
              <img src="../../../../assets/img/NOSOTROS/Team/logo twitter.svg" alt="">
            </a>
          </div>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="item-person">
          <div class="item-person-img" style="background: url(../../../../assets/img/NOSOTROS/Team/foto\ javier.svg);">
          </div>
          <span class="text-blue-qaira"><b>Javier Calvo-Pérez</b></span> <br>
          <span class="text-sm">{{'team.javier_title' | translate}}</span>
          <p class="text-sm text-justify mt-3">{{'team.javier_description' | translate}}</p>
          <div class="item-person-media">
            <a href=" https://www.linkedin.com/in/javiercalvop%C3%A9rez/" target="_blank">
              <img src="../../../../assets/img/NOSOTROS/Team/logo linkedin.svg" alt="">
            </a>
            <a href="#">
              <img src="../../../../assets/img/NOSOTROS/Team/logo twitter.svg" alt="">
            </a>
          </div>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="item-person">
          <div class="item-person-img"
            style="background: url(../../../../assets/img/NOSOTROS/Team/foto\ guillermo.svg);">
          </div>
          <span class="text-blue-qaira"><b>Guillermo Checa</b></span> <br>
          <span class="text-sm">{{'team.guillermo_title' | translate}}</span>
          <p class="text-sm text-justify mt-3">{{'team.guillermo_description' | translate}}</p>
          <div class="item-person-media">
            <a href="https://www.linkedin.com/in/guillermocheca/" target="_blank">
              <img src="../../../../assets/img/NOSOTROS/Team/logo linkedin.svg" alt="">
            </a>
            <a href="#">
              <img src="../../../../assets/img/NOSOTROS/Team/logo twitter.svg" alt="">
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>


  <svg class="wave-bottom" viewBox="0 0 500 150" preserveAspectRatio="none">
    <path d="M-0.27,2.47 C154.91,131.73 363.71,148.52 505.92,-8.38 L507.62,-9.38 L-1.97,-2.45 Z">
    </path>
  </svg>
</section>
<!-- END SECCION JUNTA DIRECTIVA -->
<!-- SECCION JUNTA DE ASESORES -->
<section class="bg-white">
  <div class="container py-2 text-center">
    <h1 class="font-weight-bolder">{{'team.advisors' | translate}}</h1>
    <div class="row justify-content-md-center">
      <div class="col-lg-4">
        <div class="item-person">
          <div class="item-person-img" style="background: url(../../../../assets/img/NOSOTROS/Team/foto\ edwin.svg);">
          </div>
          <span class="text-blue-qaira"><b>Edwin Villanueva</b></span> <br>
          <span class="text-sm">{{'team.edwin_title' | translate}}</span>
          <p class="text-sm text-justify mt-3">{{'team.edwin_description' | translate}}</p>
          <div class="item-person-media">
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="item-person">
          <div class="item-person-img"
            style="background: url(../../../../assets/img/NOSOTROS/Team/foto\ luis\ angulo.svg);">
          </div>
          <span class="text-blue-qaira"><b>José Luis Angulo</b></span> <br>
          <span class="text-sm">{{'team.jose_title' | translate}}</span>
          <p class="text-sm text-justify mt-3">{{'team.jose_description' | translate}}</p>
          <div class="item-person-media">
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- END SECCION JUNTA DE ASESORES -->
<!-- SECCION Medio Ambiente-->
<section class="section-wave">
  <svg class="wave-top" viewBox="0 0 500 150" preserveAspectRatio="none">
    <path d="M-0.27,149.50 C115.97,-14.30 374.43,-3.45 500.27,150.48 L501.41,152.45 L-1.97,150.48 Z">
    </path>
  </svg>
  <div class="container py-4 text-center">
    <h1 class="font-weight-bolder">Monitoreo Ambiental</h1>
    <div class="row justify-content-md-center">
      <div class="col-lg-3">
        <div class="item-person">
          <div class="item-person-img" style="background: url(../../../../assets/img/NOSOTROS/equipo/steven.svg);">
          </div>
          <span class="text-blue-qaira"><b>Steven Arce</b></span> <br>
          <span class="text-sm">{{'team.steven_title' | translate}}</span>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="item-person">
          <div class="item-person-img" style="background: url(../../../../assets/img/NOSOTROS/equipo/bianca.svg);">
          </div>
          <span class="text-blue-qaira"><b>Bianca Estrada</b></span> <br>
          <span class="text-sm">Analista ambiental</span>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="item-person">
          <div class="item-person-img" style="background: url(../../../../assets/img/NOSOTROS/equipo/javier.svg);">
          </div>
          <span class="text-blue-qaira"><b>Javier Mendoza</b></span> <br>
          <span class="text-sm">Ingeniero de campo</span>
        </div>
      </div>
    </div>
    <div class="col-lg-2"></div>
  </div>
  <svg class="wave-bottom" viewBox="0 0 500 150" preserveAspectRatio="none">
    <path d="M-0.27,2.47 C154.91,131.73 363.71,148.52 505.92,-8.38 L507.62,-9.38 L-1.97,-2.45 Z">
    </path>
  </svg>
</section>
<!-- END SECCION Medio ambiente -->
<!-- SECCION Comercial-->
<section class="bg-white">
  <div class="container py2 text-center">
    <h1 class="font-weight-bolder">{{'team.commercial' | translate}}</h1>
    <div class="row pb-5">
      <div class="col-lg-3">
        <div class="item-person">
          <div class="item-person-img" style="background: url(../../../../assets/img/NOSOTROS/equipo/jose_luis.svg);">
          </div>
          <span class="text-blue-qaira"><b>José Luis Hurtado</b></span> <br>
          <span class="text-sm">{{'team.julissa_title' | translate}}</span>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="item-person">
          <div class="item-person-img" style="background: url(../../../../assets/img/NOSOTROS/equipo/andre.svg);">
          </div>
          <span class="text-blue-qaira"><b>André Rengifo</b></span> <br>
          <span class="text-sm">Analista comercial</span>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="item-person">
          <div class="item-person-img" style="background: url(../../../../assets/img/NOSOTROS/equipo/hector.svg);">
          </div>
          <span class="text-blue-qaira"><b>Héctor Mora</b></span> <br>
          <span class="text-sm">{{'team.hector_title' | translate}}</span>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="item-person">
          <div class="item-person-img" style="background: url(../../../../assets/img/NOSOTROS/equipo/katherine.svg);">
          </div>
          <span class="text-blue-qaira"><b>Katherine Parra</b></span> <br>
          <span class="text-sm">Practicante de diseño</span>
        </div>
      </div>
      <div class="col-lg-2"></div>
    </div>    
  </div>
</section>
<!-- END SECCION Comercial-->
<!--SECCION ADMINISTRATIVA -->
<section class="section-wave">
  <!-- <svg class="wave-top" viewBox="0 0 500 150" preserveAspectRatio="none">
    <path d="M-0.27,149.50 C115.97,-14.30 374.43,-3.45 500.27,150.48 L501.41,152.45 L-1.97,150.48 Z">
    </path>
   </svg> -->
  <div class="container py2 text-center">
    <h1 class="font-weight-bolder">{{'team.admin' | translate}}</h1>
    <div class="row pb-5">
      <div class="col-lg-3">
        <div class="item-person">
          <div class="item-person-img" style="background: url(../../../../assets/img/NOSOTROS/equipo/jazmin.svg);">
          </div>
          <span class="text-blue-qaira"><b>Jazmín Martinez</b></span> <br>
          <span class="text-sm">Líder administrativo</span>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="item-person">
          <div class="item-person-img" style="background: url(../../../../assets/img/NOSOTROS/equipo/xiomara.svg);">
          </div>
          <span class="text-blue-qaira"><b>Xiomara Carhuaz</b></span> <br>
          <span class="text-sm">Asistente logístico y proyectos</span>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="item-person">
          <div class="item-person-img" style="background: url(../../../../assets/img/NOSOTROS/equipo/oscar.svg);">
          </div>
          <span class="text-blue-qaira"><b>Oscar Abarca</b></span> <br>
          <span class="text-sm">Practicante de finazas</span>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="item-person">
          <div class="item-person-img" style="background: url(../../../../assets/img/NOSOTROS/equipo/edith.svg);">
          </div>
          <span class="text-blue-qaira"><b>Edith Cáceres</b></span> <br>
          <span class="text-sm">{{'team.edith_title' | translate}}</span>
        </div>
      </div>
    </div>
  </div>
  <!-- <svg class="wave-bottom" viewBox="0 0 500 150" preserveAspectRatio="none">
    <path d="M-0.27,2.47 C154.91,131.73 363.71,148.52 505.92,-8.38 L507.62,-9.38 L-1.97,-2.45 Z" >
    </path>
  </svg> -->
</section>
<!--END SECCION ADMINISTRATIVA -->
<!-- END SECCION RRHH* -->
<section class="bg-white">
  <div class="container py-5 text-center">
    <h1 class="font-weight-bolder">Recursos humanos</h1>
    <div class="row justify-content-md-center">
      <div class="col-lg-4">
        <div class="item-person">
          <div class="item-person-img" style="background: url(../../../../assets/img/NOSOTROS/equipo/scarle.svg);">
          </div>
          <span class="text-blue-qaira"><b>Scarle Rojas</b></span> <br>
          <span class="text-sm">Analista de RRHH</span>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="item-person">
          <div class="item-person-img" style="background: url(../../../../assets/img/NOSOTROS/equipo/astrid.svg);">
          </div>
          <span class="text-blue-qaira"><b>Astrid Araujo</b></span> <br>
          <span class="text-sm">Practicante de RRHH</span>
        </div>
      </div>
      <!-- <div class="col-lg-4">
        <div class="item-person">
          <div class="item-person-img" style="background: url(../../../../assets/img/NOSOTROS/Team/miguel.svg);">
          </div>
          <span class="text-blue-qaira"><b>Miguel Mendoza</b></span> <br>
          <span class="text-sm">{{'team.gerson_title' | translate}}</span>
        </div>
      </div> -->
    </div>
  </div>
</section>
<!-- END SECCION RRHH* -->
<!-- SECCION HARDWARE -->
<section class="section-wave">
  <svg class="wave-top" viewBox="0 0 500 150" preserveAspectRatio="none">
    <path d="M-0.27,149.50 C115.97,-14.30 374.43,-3.45 500.27,150.48 L501.41,152.45 L-1.97,150.48 Z">
    </path>
  </svg>
  <div class="container py2 text-center">
    <h1 class="font-weight-bolder">{{'team.hardware' | translate}}</h1>
    <div class="row justify-content-md-center">
      <div class="col-lg-3">
        <div class="item-person">
          <div class="item-person-img" style="background: url(../../../../assets/img/NOSOTROS/equipo/omar.svg);">
          </div>
          <span class="text-blue-qaira"><b>Omar Vilcapoma</b></span> <br>
          <span class="text-sm">Líder de ingeniería</span>
        </div>
      </div>
    </div>    
  </div>
</section>
<!-- SECCION SOFTWARE -->
<section class="bg-white">
  <div class="container py-5 text-center">
    <h1 class="font-weight-bolder">{{'team.software' | translate}}</h1>
    <div class="row justify-content-md-center">
      <div class="col-lg-4">
        <div class="item-person">
          <div class="item-person-img" style="background: url(../../../../assets/img/NOSOTROS/equipo/victor.svg);">
          </div>
          <span class="text-blue-qaira"><b>Victor Reátegui</b></span> <br>
          <span class="text-sm">{{'team.sab_title' | translate}}</span>
        </div>
      </div>
      <!-- <div class="col-lg-4">
        <div class="item-person">
          <div class="item-person-img" style="background: url(../../../../assets/img/NOSOTROS/Team/foto\ renato.svg);">
          </div>
          <span class="text-blue-qaira"><b>Renato Vilquiniche</b></span> <br>
          <span class="text-sm">{{'team.renato_title' | translate}}</span>
        </div>
      </div> -->
      <!-- <div class="col-lg-4">
        <div class="item-person">
          <div class="item-person-img" style="background: url(../../../../assets/img/NOSOTROS/Team/miguel.svg);">
          </div>
          <span class="text-blue-qaira"><b>Miguel Mendoza</b></span> <br>
          <span class="text-sm">{{'team.gerson_title' | translate}}</span>
        </div>
      </div> -->
    </div>
  </div>
</section>
<!-- END SECCION SOFTWARE -->